import { gql } from '@apollo/client'

import HOF_FRAGMENT from 'src/components/sections/HallOfFame/fragments'

export default gql`
  query Editor {
    hallOfFame: hallOfFamers(perPage: 6, type: WEBSITE) {
      ...HallOfFameComponent
    }
  }

  ${HOF_FRAGMENT}
`
